/* eslint-disable brace-style */
import { Component, OnDestroy, OnInit, inject, signal } from '@angular/core';

import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  AbstractDialog,
  AbstractDialogData,
  AbstractDialogResultData,
} from '@next/core-lib/dialog';
import { RelationshipsActions } from '@next/core-lib/relationships';
import { UserSelectors } from '@next/core-lib/user';
import { Store, select } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { IntermediaryService } from 'src/app/shared/services/intermediary.service';

import { OfferOverviewModel } from '../../../overview/models/overview.model';
import * as OffersOverviewSlideActions from '../store/offers-overview-slide.actions';

interface OffersOverviewDialogData extends AbstractDialogData {
  selectedOffer?: OfferOverviewModel;
}

@Component({
  selector: 'app-offers-overview-slide',
  templateUrl: './offers-overview-slide.component.html',
  styleUrls: ['./offers-overview-slide.component.scss'],
  standalone: false,
})
export class OffersOverviewSlideComponent
  extends AbstractDialog<OffersOverviewDialogData>
  implements OnInit, OnDestroy
{
  data = inject<OffersOverviewDialogData>(MAT_DIALOG_DATA);
  mdDialogRef =
    inject<
      MatDialogRef<OffersOverviewSlideComponent, AbstractDialogResultData<OffersOverviewDialogData>>
    >(MatDialogRef);
  private readonly intermediaryService = inject(IntermediaryService);
  private readonly store = inject(Store);

  intermediaries = signal<string[]>([]);
  selectedLocation$ = this.store.pipe(select(UserSelectors.selectLocation));
  selectedUserLocations$ = this.store.pipe(select(UserSelectors.selectAllLocations));

  formGroup = new FormGroup({
    preferredIntermediary: new FormControl(undefined, [Validators.required]),
  });

  readonly destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.data.disableClose = true;

    this.intermediaryService
      .getIntermediaries()
      .pipe(takeUntil(this.destroy$))
      .subscribe((intermediaries) => this.intermediaries.set(intermediaries));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openLocationsDialog() {
    this.store.dispatch(RelationshipsActions.openLocationsDialog());
  }

  makeMatch() {
    const selectedIntermediary = this.formGroup.get('preferredIntermediary').value;
    if (this.data.selectedOffer && this.data.selectedOffer.id && this.formGroup.valid) {
      this.store.dispatch(
        OffersOverviewSlideActions.offerMakeMatch({
          offerId: this.data.selectedOffer.id,
          intermediary: selectedIntermediary,
        }),
      );
      this.mdDialogRef.close();
    }
  }
}
